import classNames from 'classnames';
import * as React from 'react';
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import styles from './Processing.module.scss.js';

var overlayFadeEnterTimeout = 200;
var overlayFadeLeaveTimeout = 200;
var Processing = function (props) {
    var label = props.label, isFetching = props.isFetching, isInside = props.isInside, useSpinner = props.useSpinner, className = props.className;
    var render = function () {
        var _a;
        if (useSpinner) {
            return (React.createElement("div", { key: "loader", className: classNames(styles.processingSpinner, className) },
                React.createElement("div", { className: styles.processingSpinnerInner },
                    React.createElement("div", { className: styles.processingSpinnerIcon }),
                    React.createElement("div", { className: styles.processingSpinnerText }, label))));
        }
        else {
            return (React.createElement("div", { key: "spinner", className: classNames((_a = {},
                    _a[styles.processingInside] = !!isInside,
                    _a[styles.processing] = !isInside,
                    _a), className) },
                React.createElement("div", { className: styles.spinner }),
                !!label ? React.createElement("div", { className: styles.label }, label) : null));
        }
    };
    return (React.createElement(ReactCSSTransitionGroup, { transitionName: "overlay-fade", transitionEnterTimeout: overlayFadeEnterTimeout, transitionLeaveTimeout: overlayFadeLeaveTimeout }, isFetching ? render() : null));
};

export { Processing as default };
//# sourceMappingURL=Processing.js.map
